import * as constants from './const'
let backendHost = constants.hostapi;
let socketHost = constants.SocketEndPoint;
let ssoHost;
let casinoHost = constants.CasinoAPI;
let reportsHost = constants.ReportsAPI;
let sentryDsn = constants.SentryKeyDsn;
let xoropeHost = constants.XORO_API;
let sportBattleBaseHost = constants.SportBattleBaseUrl;



const currentHost = window && window.location && window.location.origin;
// let imageBasePath;

// const hostname = window && window.location && window.location.hostname;

// if (hostname.includes(constants.localhost)) {
//   // backendHost = constants.livehostapi;
//   // socketHost = constants.liveSocketEndPoint;
//   // casinoHost = constants.liveCasinoAPI;
//   // reportsHost = constants.liveReportsAPI;
//   // sentryDsn = constants.liveSentryKeyDsn;
//   // xoropeHost = constants.XORO_API;
//   backendHost = constants.qaServerApi;
//   socketHost = constants.qaSocketEndPoint;
//   casinoHost = constants.qaCasinoAPI;
//   reportsHost = constants.qaReportsAPI;
//   sentryDsn = constants.qaSentryKeyDsn;
//   xoropeHost = constants.QA_XORO_API;
// } else if (hostname.includes(constants.qaServer)) {
//   backendHost = constants.qaServerApi;
//   socketHost = constants.qaSocketEndPoint;
//   casinoHost = constants.qaCasinoAPI;
//   reportsHost = constants.qaReportsAPI;
//   sentryDsn = constants.qaSentryKeyDsn;
//   xoropeHost = constants.QA_XORO_API;
//   // imageBasePath = constants.qaImagePath;
// } else if (hostname.includes(constants.livehost)) {
//   backendHost = constants.livehostapi;
//   socketHost = constants.liveSocketEndPoint;
//   casinoHost = constants.liveCasinoAPI;
//   reportsHost = constants.liveReportsAPI;
//   sentryDsn = constants.liveSentryKeyDsn;
//   xoropeHost = constants.XORO_API;
//   // imageBasePath = constants.liveImagePath;
// }  else {
//   backendHost = process.env.REACT_APP_BACKEND_HOST || constants.qaServerApi;
//   socketHost = constants.qaSocketEndPoint;
//   casinoHost = constants.qaCasinoAPI;
//   sentryDsn = constants.qaSentryKeyDsn;
//   xoropeHost = constants.QA_XORO_API;
//   // imageBasePath = constants.qaImagePath;
// }

export const API_ROOT = `${backendHost}/`;
export const APP_ROOT = `${currentHost}/`;
export const SSO_ROOT = `${ssoHost}/`;
export const SOCKET_ROOT = `${socketHost}/`;
export const CASINO_ROOT = `${casinoHost}/`;
export const REPORTS_ROOT = `${reportsHost}/`;
export const SENTRY_DSN = `${sentryDsn}`;
export const XOROPE_ROOT = `${xoropeHost}`;
export const SPORTBATTLEBASE_ROOT = `${sportBattleBaseHost}`;
// export const BASE_IMAGE_PATH= `${imageBasePath}`;
